export const countrySelector: object = {
  countrySelector: {
    countryRegion: 'Country/Region',
    countrySwitcherTitle: 'Choose a Country/Region',
    englishOnly: 'Language: English Only',
    selectCountryDescription: 'Please select your country or region to see local pricing.',
    searchPlaceholder: 'Search Countries and Regions',
    countrySwitchModal: {
      confirmAndVisitHomepage: 'Confirm and visit Homepage',
      withdrawCountrySelection: 'Withdraw Country Selection',
      solutionNotAvailable: 'This solution is not available in',
      redirectToHomepage: 'To proceed you will be redirected to the Homepage',
      warning: 'Warning',
    }
  }
};
